import { useCallback, useRef } from 'react';

const prefetched = new Set<string>();

const ROUTE_IMPORTS: Record<string, () => Promise<unknown>> = {
  '/home': () => import('@/pages/Home'),
  '/pricing': () => import('@/pages/Pricing'),
  '/demo': () => import('@/pages/Demo'),
  '/slaw-landing': () => import('@/pages/SLAWLanding'),
  '/slaw-detection': () => import('@/pages/SLAWDetection'),
  '/decision-engine': () => import('@/pages/DecisionEngine'),
  '/crm': () => import('@/pages/CrmConnections'),
  '/mapping': () => import('@/pages/SavedMappings'),
  '/rules': () => import('@/pages/RulesEngine'),
  '/analytics': () => import('@/pages/BrainAnalytics'),
};

export function usePrefetchRoute() {
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  const prefetch = useCallback((path: string) => {
    if (prefetched.has(path)) return;
    
    timerRef.current = setTimeout(() => {
      const loader = ROUTE_IMPORTS[path];
      if (loader) {
        prefetched.add(path);
        loader().catch(() => prefetched.delete(path));
      }
    }, 100);
  }, []);

  const cancel = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
  }, []);

  return { prefetch, cancel };
}
